import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="bg-white/80 backdrop-blur-md border-t border-gray-200 py-12 px-6 mt-auto">
            <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
                <div className="flex flex-col">
                    <div className="flex items-center gap-2 mb-4">
                        <img src="/logo.svg" alt="Akhandaa Logo" className="h-8 w-auto object-contain" />
                        <img
                            src="/Akhandaa.svg"
                            alt="Akhandaa"
                            className="h-5 w-auto object-contain"
                        />
                    </div>
                    <p className="text-gray-500 text-sm">Your path to divine discoveries</p>
                </div>
                <div>
                    <h3 className="font-bold text-gray-900 mb-4">Quick Links</h3>
                    <ul className="space-y-3 text-sm text-gray-600 font-medium">
                        <li><Link to="/" className="hover:text-sky-600 transition">Home</Link></li>
                        <li><Link to="/about" className="hover:text-sky-600 transition">About Us</Link></li>
                        <li><Link to="/blogs" className="hover:text-sky-600 transition">Blog</Link></li>
                        <li><Link to="/terms" className="hover:text-sky-600 transition">Terms & Conditions</Link></li>
                        <li><Link to="/privacy" className="hover:text-sky-600 transition">Privacy Policy</Link></li>
                    </ul>
                </div>
                <div>
                    <h3 className="font-bold text-gray-900 mb-4">Sacred Yatras</h3>
                    <ul className="space-y-3 text-sm text-gray-600 font-medium">
                        <li><Link to="/char-dham-yatra" className="hover:text-sky-600 transition">Char Dham Yatra</Link></li>
                        <li><Link to="/amarnath-yatra" className="hover:text-sky-600 transition">Amarnath Yatra</Link></li>
                        <li><Link to="/pancha-bhoota-sthalam" className="hover:text-sky-600 transition">Pancha Bhoota Sthalam</Link></li>
                        <li><Link to="/arupadai-veedu" className="hover:text-sky-600 transition">Arupadai Veedu</Link></li>
                        <li><Link to="/mukti-kshetras-karnataka" className="hover:text-sky-600 transition">Karnataka Mukti Kshetras</Link></li>
                        <li><Link to="/shakti-peethas" className="hover:text-sky-600 transition">Shakti Peethas</Link></li>
                        <li><Link to="/jyotirlingas" className="hover:text-sky-600 transition">Jyotirlingas</Link></li>
                    </ul>
                </div>
                <div>
                    <h3 className="font-bold text-gray-900 mb-4">Connect With Us</h3>
                    <ul className="space-y-3.5 text-sm text-gray-600 font-medium">
                        <li className="flex items-center gap-2.5">
                            {/* Official Gmail Icon */}
                            <svg className="w-5 h-5 shrink-0" viewBox="0 0 24 24">
                                <path fill="#4285F4" d="M22 6.5V18C22 19.1 21.1 20 20 20H17V10L22 6.5Z"/>
                                <path fill="#34A853" d="M7 20H4C2.9 20 2 19.1 2 18V6.5L7 10V20Z"/>
                                <path fill="#EA4335" d="M17 10L12 13.5L7 10V4.5L12 8.25L17 4.5V10Z"/>
                                <path fill="#FBBC05" d="M20 4H17V4.5L22 8.25V6.5C22 5.12 20.88 4 20 4Z"/>
                                <path fill="#C5221F" d="M4 4H7V4.5L2 8.25V6.5C2 5.12 3.12 4 4 4Z"/>
                            </svg>
                            <a href="mailto:akhandaaservice@gmail.com" className="hover:text-sky-600 transition font-medium">akhandaaservice@gmail.com</a>
                        </li>
                        <li>
                            <a
                                href="https://www.instagram.com/akhandaa_official?igsi=MXRibG9mNjVkdW5ncg=="
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2.5 text-gray-700 hover:text-pink-600 font-medium transition-all group"
                            >
                                <div className="w-6 h-6 rounded-lg bg-gradient-to-tr from-amber-400 via-rose-500 to-purple-600 text-white flex items-center justify-center shrink-0 shadow-sm group-hover:scale-110 transition-transform">
                                    <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 24 24">
                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                    </svg>
                                </div>
                                <span>Instagram</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-gray-100 text-center text-gray-400 text-xs font-semibold tracking-widest uppercase">
                &copy; {new Date().getFullYear()} AKHANDAA. ALL RIGHTS RESERVED.
            </div>
        </footer>
    );
};

export default Footer;
